(function(){
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {threshold:.15, rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.reveal, .stagger').forEach(function(el){ io.observe(el); });

  function fmt(n,dec){ return dec? n.toFixed(dec) : Math.round(n).toLocaleString('en-US'); }
  function animateCount(el){
    var target=parseFloat(el.dataset.count), dec=parseInt(el.dataset.decimals||'0',10), suffix=el.dataset.suffix||'';
    if(rm){ el.textContent=fmt(target,dec)+suffix; return; }
    var start=null, dur=1500;
    function step(ts){ if(!start)start=ts; var p=Math.min((ts-start)/dur,1); var eased=1-Math.pow(1-p,3);
      el.textContent=fmt(target*eased,dec)+suffix; if(p<1)requestAnimationFrame(step); else el.textContent=fmt(target,dec)+suffix; }
    requestAnimationFrame(step);
  }
  var cio=new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting){ animateCount(e.target); cio.unobserve(e.target);} }); },{threshold:.6});
  document.querySelectorAll('[data-count]').forEach(function(el){ cio.observe(el); });

  var razor=document.querySelector('.hero .pmedia');
  if(razor && !rm){ window.addEventListener('scroll',function(){ var y=window.scrollY; if(y<800) razor.style.transform='translateY('+(y*0.05)+'px)'; },{passive:true}); }

  var tiers=document.querySelectorAll('.tier');
  var bumpEl=document.getElementById('bump');
  var totalEl=document.getElementById('totalPrice'), saveEl=document.getElementById('saveNote');
  var sbPrice=document.getElementById('sbPrice'), sbLabel=document.getElementById('sbLabel');
  var colorName=document.getElementById('colorName');
  var BUMP = bumpEl ? (parseFloat(bumpEl.getAttribute('data-price'))||9.90) : 9.90;
  var BUMPWAS = bumpEl ? (parseFloat(bumpEl.getAttribute('data-was'))||19.90) : 19.90;
  var activeColor='Pink';
  function current(){ return document.querySelector('.tier.sel'); }

  /* Derive the store/market money format from a Liquid-rendered price so JS totals
     match the buyer's actual currency (e.g. "281,00 lei") instead of a hardcoded $. */
  var MONEY = (function(){
    var fallback = {pre:'$', suf:'', dec:'.', grp:',', places:2};
    var t = document.querySelector('.tier[data-price]');
    var el = t ? t.querySelector('.tier__price b') : null;
    if(!t || !el) return fallback;
    var amount = parseFloat(t.getAttribute('data-price'));
    var txt = (el.textContent||'').replace(/ /g,' ').trim();
    var m = txt.match(/\d[\d.,\s]*/);
    if(!m || !isFinite(amount)) return fallback;
    var num = m[0].replace(/\s+$/,'');
    var pre = txt.slice(0, m.index);
    var suf = txt.slice(m.index + num.length);
    var dec = '.', grp = ',', places = 2;
    var dm = num.match(/([.,])(\d{2})$/);
    if(dm){ dec = dm[1]; grp = (dec === ',') ? '.' : ','; places = 2; }
    else { places = 0; dec = ''; grp = /\./.test(num) ? '.' : ','; }
    return {pre:pre, suf:suf, dec:dec, grp:grp, places:places};
  })();

  function money(n){
    if(!isFinite(n)) n = 0;
    var neg = n < 0; n = Math.abs(n);
    var s = MONEY.places ? n.toFixed(MONEY.places) : String(Math.round(n));
    var bits = s.split('.');
    var int = bits[0].replace(/\B(?=(\d{3})+(?!\d))/g, MONEY.grp);
    var out = int + (MONEY.places ? MONEY.dec + bits[1] : '');
    return (neg ? '-' : '') + MONEY.pre + out + MONEY.suf;
  }

  function render(){
    var t=current(); if(!t) return;
    var price=parseFloat(t.dataset.price), was=parseFloat(t.dataset.was);
    var total=price+(bumpEl && bumpEl.checked?BUMP:0);
    totalEl.textContent=money(total);
    if(sbPrice) sbPrice.textContent=money(total);
    if(sbLabel) sbLabel.textContent=activeColor+' · '+t.dataset.label+(bumpEl && bumpEl.checked?' + head':'');
    var save=(was-price)+(bumpEl && bumpEl.checked?(BUMPWAS-BUMP):0);
    saveEl.textContent = save>0 ? 'You save '+money(save) : '';
  }
  tiers.forEach(function(t){ t.addEventListener('click',function(){ tiers.forEach(function(x){x.classList.remove('sel');}); t.classList.add('sel'); render(); }); });
  if(bumpEl) bumpEl.addEventListener('change', render);

  var swatches=document.querySelectorAll('.sw');
  var galMain=document.getElementById('galMain');
  var packThumb=document.querySelector('.gthumb--pack');
  var packThumbImg=document.getElementById('packThumbImg');
  var gthumbs=document.querySelectorAll('.gthumb');
  gthumbs.forEach(function(g){ g.addEventListener('click',function(){
    gthumbs.forEach(function(x){ x.classList.remove('sel'); }); g.classList.add('sel');
    if(galMain && g.dataset.img) galMain.src=g.dataset.img;
  }); });
  swatches.forEach(function(s){ s.addEventListener('click',function(){
    swatches.forEach(function(x){ x.classList.remove('sel'); }); s.classList.add('sel');
    activeColor=s.dataset.color; if(colorName) colorName.textContent=activeColor;
    if(s.dataset.img){
      if(packThumb) packThumb.dataset.img=s.dataset.img;
      if(packThumbImg) packThumbImg.src=s.dataset.thumb||s.dataset.img;
      if(galMain) galMain.src=s.dataset.img;
      gthumbs.forEach(function(x){ x.classList.remove('sel'); });
      if(packThumb) packThumb.classList.add('sel');
    }
    render();
  }); });
  render();

  document.querySelectorAll('.faq__q').forEach(function(q){
    q.addEventListener('click',function(){ var item=q.parentElement, open=item.classList.contains('open');
      document.querySelectorAll('.faq__item').forEach(function(i){ i.classList.remove('open'); }); if(!open) item.classList.add('open'); });
  });

  var bar=document.getElementById('stickybar'), hero=document.querySelector('.hero'), buy=document.getElementById('buy');
  if(bar && hero && buy){
    var heroOut=false, buyIn=false;
    function updateBar(){ bar.classList.toggle('show', heroOut && !buyIn); }
    var sIO=new IntersectionObserver(function(entries){ entries.forEach(function(e){
      if(e.target===hero){ heroOut=!e.isIntersecting; }
      if(e.target===buy){ buyIn=e.isIntersecting; } }); updateBar(); },{threshold:.05});
    sIO.observe(hero); sIO.observe(buy);
  }

  function pulse(btn){ var t=btn.textContent; btn.textContent='Added ✓'; btn.style.background='var(--wine)'; setTimeout(function(){ btn.textContent=t; btn.style.background=''; },1400); }
  function selectedVariant(){ var sw=document.querySelector('.sw.sel'); return sw ? (sw.dataset.variant||'') : ''; }
  function tierQty(){ var t=current(); return t ? parseInt(t.dataset.qty||'1',10) : 1; }
  function buildItems(){
    var id=selectedVariant();
    if(!id) return null;
    var qty=tierQty();
    var items=[{id:parseInt(id,10),quantity:qty}];
    var addBtn=document.getElementById('addBtn');
    var caseId=addBtn?addBtn.getAttribute('data-case'):'';
    var gloveId=addBtn?addBtn.getAttribute('data-glove'):'';
    if(qty>=2 && caseId){ items.push({id:parseInt(caseId,10),quantity:1}); }
    if(qty>=3 && gloveId){ items.push({id:parseInt(gloveId,10),quantity:1}); }
    var bump=document.getElementById('bump');
    if(bump && bump.checked && bump.dataset.variant){ items.push({id:parseInt(bump.dataset.variant,10),quantity:1}); }
    return items;
  }
  function addToCart(){
    var b=document.getElementById('addBtn');
    var items=buildItems();
    if(!items){ if(b) pulse(b); return; }
    if(window.LilyCart && window.LilyCart.addItems){ if(b) b.textContent='Adding…'; window.LilyCart.addItems(items).then(function(){ if(b) b.textContent='Add to cart'; }); return; }
    if(b){ b.textContent='Adding…'; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(){ window.location.href='/checkout'; })
      .catch(function(){ window.location.href='/cart'; });
  }
  var addBtn=document.getElementById('addBtn'); if(addBtn) addBtn.addEventListener('click', addToCart);
  var sbBtn=document.getElementById('sbBtn'); if(sbBtn) sbBtn.addEventListener('click', function(e){ e.preventDefault(); addToCart(); });
})();

(function(){
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var slider=document.getElementById('revSlider'); if(!slider) return;
  var track=slider.querySelector('.rev-track'); var cards=track.children; var dotsWrap=document.getElementById('revDots');
  var idx=0, timer;
  function perView(){ return window.innerWidth<=820?1:3; }
  function maxIdx(){ return Math.max(0, cards.length - perView()); }
  function place(){ var w=cards[0].getBoundingClientRect().width; var gap=parseFloat(getComputedStyle(track).gap)||0; track.style.transform='translateX(-'+(idx*(w+gap))+'px)'; renderDots(); }
  function go(i){ var m=maxIdx(); idx=i>m?0:(i<0?m:i); place(); }
  function renderDots(){ if(!dotsWrap) return; var n=maxIdx()+1; if(dotsWrap.children.length!==n){ dotsWrap.innerHTML=''; for(var k=0;k<n;k++){ (function(kk){ var b=document.createElement('button'); b.addEventListener('click',function(){ go(kk); reset(); }); dotsWrap.appendChild(b); })(k); } } for(var j=0;j<dotsWrap.children.length;j++){ dotsWrap.children[j].className = j===idx?'on':''; } }
  function reset(){ clearInterval(timer); if(!rm) timer=setInterval(function(){ go(idx+1); },4000); }
  slider.addEventListener('mouseenter',function(){ clearInterval(timer); });
  slider.addEventListener('mouseleave',reset);
  window.addEventListener('resize',function(){ go(Math.min(idx,maxIdx())); });
  go(0); reset();
})();